import React from 'react';
import MyJams from '../components/game/MyJams/MyJams';

export const PastEventsPage: React.FC = () => {
  return <MyJams />;
};
